import script from "./HomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeView.vue?vue&type=script&lang=ts&setup=true"

import "./HomeView.vue?vue&type=style&index=0&id=05105de4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ryuta_ariga\\source\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05105de4"]])

export default __exports__